import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Media from 'react-media';
import Modal from 'react-modal';
import qs from 'query-string';
import { filter, find, get, includes } from 'lodash';
import { hasColors, firstColor } from './helpers';
import ProductImagery from './ProductImagery';
import ProductDetailsHeader from './ProductDetailsHeader';
import ProductInfoTable from './ProductInfoTable';
import ProductSelector from '../ProductSelector/ProductSelector';
import SizingTable from './SizingTable';
import { addToCart } from '../../redux/actions';
import { fetchSizeGuide } from '../../redux/service';

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ addToCart }, dispatch);
}

const modalStyles = {
  overlay: {
    zIndex: 4
  },
  content: {
    top         :'50%',
    left        :'50%',
    right       :'auto',
    width       :'100%',
    maxWidth    :'800px',
    bottom      :'auto',
    marginRight :'-50%',
    transform   :'translate(-50%, -50%)'
  }
}

class ProductPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      product: null,
      colors: [],
      metafields: null,
      images: null,
      sizeGuide: [],
      selectedColor: null,
      showSizeGuide: false,
    }
  }

  componentWillMount() {
    // Read the current product JSON
    const { location, history } = this.props;
    const search = location.search ? qs.parse(location.search) : {};
    const json = JSON.parse(document.getElementById('product-json').innerHTML);
    const { product, shop } = json;

    let selectedColor = null;

    if (search.color) {
      selectedColor = decodeURIComponent(search.color);
    } else if (hasColors(product)) {
      // If there was no selected color, set one (if necessary)
      selectedColor = firstColor(product);
      history.push(`/products/${product.handle}?color=${encodeURIComponent(selectedColor)}`);
    }

    // Async fetch the size guide associated
    // Really this should be in redux, but seeing as the rest of the
    // content isn't there we might as well just set this on state as well
    fetchSizeGuide(shop, product.tags.join(','))
      .then(sizeGuide => this.setState({ sizeGuide }));

    this.setState({ ...json, selectedColor });
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location !== prevProps.location) {
      const search = location.search ? qs.parse(location.search) : null;
      const selectedColor = search && decodeURIComponent(search.color);
      this.setState({ selectedColor });
    }
  }

  changeProduct = (color) => {
    const { product } = this.state;
    const { history } = this.props;
    history.push(`/products/${product.handle}?color=${encodeURIComponent(color)}`);
  }

  toggleSizeGuide = (e) => {
    e.preventDefault();
    this.setState({ showSizeGuide: !this.state.showSizeGuide });
  }

  togglePriceModal = (e) => {
    e.preventDefault();
    this.setState({ showPriceModal: !this.state.showPriceModal });
  }

  toggleOriginModal = (e) => {
    e.preventDefault();
    this.setState({ showOriginsModal: !this.state.showOriginsModal });
  }

  renderMobile() {
    const { product, colors, images, metafields, selectedColor, sizeGuide } = this.state;
    const { addToCart } = this.props;

    const originImage = find(images,
      image => image.alt.toLowerCase().includes('origin'));

    return (
      <div className="product-page js-product-page">
        <ProductDetailsHeader
          title={product.title}
        />

        {this.renderImages()}

        <p
          className="product-details__description"
          dangerouslySetInnerHTML={{ __html: product.description }}
        />

        {originImage &&
          <a
            href="#"
            onClick={this.toggleOriginModal}
            className="learn-more-link"
          >
            Product origins
          </a>}

        <ProductInfoTable
          details={get(metafields, 'info.details')}
          fabric={get(metafields, 'info.fabric')}
          sizing={get(metafields, 'info.sizing')}
          sizeGuide={sizeGuide.length > 0}
          toggleSizeGuide={this.toggleSizeGuide}
        />

        <ProductSelector
          product={product}
          colorSwatches={colors}
          selectedColor={selectedColor}
          onSelectColor={this.changeProduct}
          addToCart={addToCart}
          retailPrice={get(metafields, 'info.retail_price')}
        />
      </div>
    );
  }

  renderDesktop() {
    const {
      product,
      sizeGuide,
      colors,
      metafields,
      images,
      selectedColor,
    } = this.state;
    const { addToCart } = this.props;

    const originImage = find(images,
      image => image.alt.toLowerCase().includes('origin'));

    const priceBreakdownImage = find(images,
      image => image.alt.toLowerCase().includes('price'));

    return (
      <div className="product-page js-product-page">
        <section className="product-page__details">
          <div className="product-page__details-inner">
            <ProductDetailsHeader
              title={product.title}
              color={selectedColor}
              description={product.description}
              originImage={originImage}
              toggleOriginModal={this.toggleOriginModal}
            />

            <div className="product-details__selector">
              <ProductSelector
                product={product}
                colorSwatches={colors}
                selectedColor={selectedColor}
                onSelectColor={this.changeProduct}
                addToCart={addToCart}
                isLoading={false}
                retailPrice={get(metafields, 'info.retail_price')}
                priceBreakdownImage={priceBreakdownImage}
                togglePriceModal={this.togglePriceModal}
              />
            </div>

            <ProductInfoTable
              details={get(metafields, 'info.details')}
              fabric={get(metafields, 'info.fabric')}
              sizing={get(metafields, 'info.sizing')}
              sizeGuide={sizeGuide.length > 0}
              toggleSizeGuide={this.toggleSizeGuide}
            />
          </div>
        </section>
        <section className="product-page__imagery">
          {this.renderImages()}
        </section>
      </div>
    );
  }

  renderImages() {
    const { images, selectedColor } = this.state;
    const variantImages = filter(images, image => image.alt === selectedColor);

    return (
      <ProductImagery
        images={variantImages.length ? variantImages : images}
      />
    );
  }

  render() {
    const {
      sizeGuide,
      images,
      showSizeGuide,
      showOriginsModal,
      showPriceModal,
    } = this.state;

    const originImage = find(images,
      image => image.alt.toLowerCase().includes('origin'));

    const priceBreakdownImage = find(images,
      image => image.alt.toLowerCase().includes('price'));

    return (
      <React.Fragment>
        <Media query={{ maxWidth: 599 }}>
          {matches => matches
            ? this.renderMobile()
            : this.renderDesktop()}
        </Media>

        {sizeGuide.length > 0 &&
          <Modal
            isOpen={showSizeGuide}
            onRequestClose={this.toggleSizeGuide}
            style={modalStyles}>
            <SizingTable sizeGuide={sizeGuide[0]} />
          </Modal>}

        {originImage &&
          <Modal
            isOpen={showOriginsModal}
            onRequestClose={this.toggleOriginModal}
            style={modalStyles}>
            <img src={originImage.src} className="product-page__modal-img" />
          </Modal>}

        {priceBreakdownImage &&
          <Modal
            isOpen={showPriceModal}
            onRequestClose={this.togglePriceModal}
            style={modalStyles}>
            <img src={priceBreakdownImage.src} className="product-page__modal-img" />
          </Modal>}
      </React.Fragment>
    );
  }
}

export default connect(null, mapDispatchToProps)(ProductPage);


// WEBPACK FOOTER //
// ./assets/scripts/components/Product/ProductPage.js